// Utilitário para padronizar badges de papéis na UI
// Fornece mapeamentos para papéis globais de usuários e papéis de projeto

// Retorna classe CSS padronizada (badge-*) e texto exibido para papéis globais
export function getGlobalUserRoleBadgeInfo(role) {
  const raw = String(role || '').trim().toLowerCase();
  switch (raw) {
    case 'admin':
    case 'adm':
      return { class: 'badge-admin', text: 'ADM' };
    case 'manager':
    case 'gerencial':
      return { class: 'badge-manager', text: 'GERENCIAL' };
    case 'dev':
    case 'designer':
    case 'programador':
    case 'developer':
      return { class: 'badge-dev', text: 'DEV' };
    case 'tester':
    case 'qa':
      return { class: 'badge-tester', text: 'QA' };
    case 'viewer':
    case 'consulta':
    case 'readonly':
      return { class: 'badge-viewer', text: 'CONSULTA' };
    default:
      return { class: 'badge-viewer', text: (role ? String(role).toUpperCase() : 'CONSULTA') };
  }
}

// Retorna classe CSS padronizada (badge-*) e texto exibido para papéis de projeto
export function getProjectRoleBadgeInfo(roleKey) {
  const key = String(roleKey || '').trim().toLowerCase();
  switch (key) {
    case 'leader':
      return { class: 'badge-manager', text: 'GERENCIAL' };
    case 'tester':
      return { class: 'badge-tester', text: 'QA' };
    case 'developer':
    case 'dev':
    case 'designer':
    case 'programador':
      return { class: 'badge-dev', text: 'DEV' };
    case 'readonly':
      return { class: 'badge-viewer', text: 'CONSULTA' };
    default:
      return null;
  }
}